/** Verified public store listings for the Livewello mobile apps. */
export const MOBILE_APP_STORE_URLS = {
  apple: 'https://apps.apple.com/app/id6784714209',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.livewello.app',
} as const

export const MOBILE_APP_LANDING_ASSETS = {
  iosGeneticsScreenshot: '/images/landing/mobile-app/ios-genetics-report.png',
  androidGoalsScreenshot: '/images/landing/mobile-app/android-goals-streak.png',
  appStoreBadge: '/images/landing/mobile-app/app-store-badge.svg',
  googlePlayBadge: '/images/landing/mobile-app/google-play-badge.png',
} as const
